import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { Cms } from '../cms/models/cms.model';
import { Router, ActivatedRoute } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { CmsStudioService } from '../cms/cms-studio.service';
import { CmsViewDirectiveService } from '../cms/cmsdirectives/cmsviewdirective.service';

@Component({
  selector: 'app-kb',
  templateUrl: './kb.component.html',
  styleUrls: ['./kb.component.css']
})
export class KbComponent implements OnInit {
  title = 'Knowledge Base';
  /*component: any;
  setFullWindow = false;
  subWidth: string;
  cms: Cms;
  viewChildId = null;*/
  breadcrumbs = [{ label: "Knowledge Base", url: "/kb" }];

  constructor(private router: Router, private ngProgress: NgProgress, private activeRouter: ActivatedRoute, 
    private cmsStudioService: CmsStudioService) { }

  ngOnInit() {
    /*this.cmsStudioService.getCmsHomePage()
      .subscribe(res => {
        console.log(res);
        if (res.stat == "success") {
          this.cms = res.cms;
        }
      })*/
  }

  /*clickEvent(e) {
    console.log(e.target.dataset.id);
    if (e.target.dataset.class = 'cmsTemplate' && this.viewChildId != e.target.dataset.id) {
      jQuery("app-cms-view-directive").hide();
      this.service.setRootViewContainerRef(this.viewContainerRef);
      this.service.addDynamicComponent(e.target.dataset.id);
      this.viewChildId = e.target.dataset.id;
      $('.page-contents').animate({ scrollLeft: $('app-cms-studio-preview').width() + 250 }, 400);
    }
  }*/
}
